import { createTheme } from "@mui/material/styles";

import {
  designTokens,
  type DesignTokens,
} from "./shared/styles/tokens";

declare module "@mui/material/styles" {
  interface Theme {
    design: DesignTokens;
  }
  interface ThemeOptions {
    design?: DesignTokens;
  }
}

const { color, typography, breakpoint } = designTokens;
const fontFamily = typography.fontFamily;

const theme = createTheme({
  design: designTokens,
  typography: {
    fontFamily,
    allVariants: {
      fontFamily,
    },
  },

  components: {
    MuiCssBaseline: {
      styleOverrides: {
        body: {
          fontFamily,
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: { fontFamily },
      },
    },
    MuiTypography: {
      styleOverrides: {
        root: { fontFamily },
      },
    },
    MuiInputBase: {
      styleOverrides: {
        root: { fontFamily },
        input: { fontFamily },
      },
    },
    MuiInputLabel: {
      styleOverrides: {
        root: { fontFamily },
      },
    },
    MuiMenuItem: {
      styleOverrides: {
        root: { fontFamily },
      },
    },
    MuiTab: {
      styleOverrides: {
        root: { fontFamily },
      },
    },
    MuiLink: {
      styleOverrides: {
        root: { fontFamily },
      },
    },
    MuiFormHelperText: {
      styleOverrides: {
        root: { fontFamily },
      },
    },
    MuiTooltip: {
      styleOverrides: {
        tooltip: { fontFamily },
      },
    },
  },

  palette: {
    background: {
      default: color.surface.canvas,
      paper: color.surface.raised,
    },
    text: {
      primary: color.text.primary,
      secondary: color.text.secondary,
    },
  },

  breakpoints: {
    values: breakpoint,
  },
});

export default theme;
